import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import ChangePasswordForm from "components/account/ChangePasswordForm";
import { useAuth } from "contexts/AuthContext";
import { apiGet } from "lib/apiClient";
import { getRememberedSeat, seatHomePath } from "lib/seats";
import { RoleChooser } from "views/auth/SignIn";

export default function SetPassword() {
  const { status, user, refresh, logout } = useAuth();
  const navigate = useNavigate();
  const [chooserSeats, setChooserSeats] = useState(null);

  if (status === "loading") {
    return <div className="flex h-screen w-full items-center justify-center text-sm text-gray-500">Loading…</div>;
  }
  if (status === "signed-out") return <Navigate to="/auth/sign-in" replace />;

  async function afterPasswordSet() {
    const suspendedCode = await refresh();
    if (suspendedCode) return;
    const remembered = getRememberedSeat();
    if (remembered) {
      navigate(seatHomePath(remembered.kind), { replace: true });
      return;
    }
    const held = await apiGet("/portal/seats").catch(() => null);
    const seats = held?.seats ?? [];
    if (seats.length > 1) {
      setChooserSeats(seats);
      return;
    }
    navigate("/portal", { replace: true });
  }

  return (
    <div className="flex w-full">
      <div className="w-full">
        {chooserSeats ? (
          <RoleChooser seats={chooserSeats} onChosen={(seat) => navigate(seatHomePath(seat.kind), { replace: true })} />
        ) : (
          <>
            <h4 className="mb-1.5 text-2xl font-semibold tracking-tight text-foreground">Choose your password</h4>
            <p className="mb-6 text-sm text-muted-foreground">
              {user?.email ? `You signed in as ${user.email} with a temporary password. ` : ""}
              Set a password only you know to open the portal.
            </p>
            <ChangePasswordForm
              variant="auth"
              currentLabel="Temporary password (from your welcome email)"
              submitLabel="Save and continue"
              onChanged={afterPasswordSet}
            />
            <button type="button" onClick={logout} className="mt-4 text-sm font-medium text-gray-600 hover:text-brand-500">
              Sign out
            </button>
          </>
        )}
      </div>
    </div>
  );
}
